import { Component, Inject } from '@angular/core';
import { AuditFilterFormComponent} from '../audit-filter-form/audit-filter-form.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuditFilter } from '../../audit.model';

@Component({
  selector: 'iaud-audit-filter-dialog',
  templateUrl: './audit-filter-dialog.component.html',
  styleUrls: ['./audit-filter-dialog.component.scss']
})
export class AuditFilterDialogComponent  {
  constructor(public dialogRef: MatDialogRef<AuditFilterFormComponent>,
              @Inject(MAT_DIALOG_DATA) public filter: AuditFilter) { }

  apply(): void {
    this.dialogRef.close(this.filter);
  }
  clear(): void {
    this.dialogRef.close(null);
  }
}
